<template>
    <section>
        <slot :showModal="showModal"/>
    </section>
</template>

<style scoped>
a {
    cursor: pointer;
}
</style>

<script>

export default {
    props: {
        modal: {
            type: String,
            default: null
        },
        captcha: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        showModal: function() {
            this.$store.dispatch('openModal', {
                name: this.modal,
                captcha: this.captcha
            })
        }
    },
}
</script>
